/* eslint-disable no-extend-native */
// Fix AZ (2026-10-07): Chrome 154 (datos CLDR nuevos) muestra "es-AR" en 12 hs SIN "a. m./p. m.":
// las 14:00 se veían "02:00:00". El frontend tiene 95 llamadas toLocaleString/toLocaleTimeString
// con "es-AR"; en vez de tocarlas una por una, se fuerza 24 hs (hourCycle "h23") cuando el locale es
// "es-AR" y la llamada no pide un formato de hora propio. Las fechas y los otros locales no cambian.
// Se importa PRIMERO en index.js, antes que la app.
const withH23 = (locales, options) =>
  locales === "es-AR" && !(options && ("hour12" in options || "hourCycle" in options))
    ? { ...(options || {}), hourCycle: "h23" }
    : options;

const origToLocaleString = Date.prototype.toLocaleString;
const origToLocaleTimeString = Date.prototype.toLocaleTimeString;

Date.prototype.toLocaleString = function (locales, options) {
  return origToLocaleString.call(this, locales, withH23(locales, options));
};
Date.prototype.toLocaleTimeString = function (locales, options) {
  return origToLocaleTimeString.call(this, locales, withH23(locales, options));
};
